import "./Menu.scss";
import React, { useRef, useState } from "react";
import { useTracked } from "../../state";
import { useHistory, useLocation } from "react-router-dom";
import {
  IonContent,
  IonFooter,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonListHeader,
  IonLoading,
  IonMenu,
  IonMenuToggle,
  IonThumbnail,
} from "@ionic/react";
import usersIcon from "../../assets/svg/menuIcons/users.svg";
import usersWhiteIcon from "../../assets/svg/menuIcons/users-white.svg";
import userIcon from "../../assets/svg/menuIcons/user.svg";
import userWhiteIcon from "../../assets/svg/menuIcons/user-white.svg";
import editIcon from "../../assets/svg/menuIcons/edit.svg";
import editWhiteIcon from "../../assets/svg/menuIcons/edit-white.svg";
import infoIcon from "../../assets/svg/menuIcons/info.svg";
import infoWhiteIcon from "../../assets/svg/menuIcons/info-white.svg";
import cogIcon from "../../assets/svg/menuIcons/cog.svg";
import cogWhiteIcon from "../../assets/svg/menuIcons/cog-white.svg";
import logoutIcon from "../../assets/svg/logout.svg";
import qrIcon from "../../assets/svg/qr.svg";
import { identityService } from "../../services/vault";
import { chevronDown, chevronUp, fingerPrint } from "ionicons/icons";
import QrCodeModal from "../QrCodeModal";
import clsx from "clsx";
import { Plugins } from "@capacitor/core";
import MockDelay from "../../utils/helpers/MockDelay";
import { AuthMode } from "@ionic-enterprise/identity-vault";
import { ShowToastErrorMessage } from "../../utils/helpers/ToastMessage";
import { loadAuthMode } from "../../context/vault";
import { userRemovePushToken } from "../../api/user";

const { Storage } = Plugins;
interface AppPage {
  url: string;
  iosIcon: string;
  iosIconSelected?: string;
  mdIcon: string;
  title: string;
  subMenus?: any;
}

const appPages: AppPage[] = [
  // {
  //   title: 'Abaxx Verify',
  //   url: '/page/Verify',
  //   iosIcon: checkmarkOutline,
  //   mdIcon: checkmarkSharp
  // },
  {
    title: "Issuers",
    url: "/issuers",
    iosIcon: usersIcon,
    iosIconSelected: usersWhiteIcon,
    mdIcon: usersIcon,
  },
  {
    title: "Aliases",
    url: "/aliases",
    iosIcon: userIcon,
    iosIconSelected: userWhiteIcon,
    mdIcon: userIcon,
  },
  {
    title: "Requests",
    url: "/requests",
    iosIcon: editIcon,
    iosIconSelected: editWhiteIcon,
    mdIcon: editIcon,
  },
  {
    title: "About ID ++",
    url: "/about",
    iosIcon: infoIcon,
    iosIconSelected: infoWhiteIcon,
    mdIcon: infoIcon,
    subMenus: [
      {
        title: "Terms & Conditions",
        url: "/terms-and-conditions",
      },
      {
        title: "Privacy Policy",
        url: "/privacy-policy",
      },
      {
        title: "Help",
        url: "/help",
      },
    ],
  },
  // {
  //   title: 'Help',
  //   url: '/page/Help',
  //   iosIcon: helpOutline,
  //   mdIcon: helpSharp
  // },
  // {
  // {
  //   title: 'Privacy Policy',
  //   // url: '/page/Privacy',
  //   url: '/privacy-policy',
  //   iosIcon: fingerPrintOutline,
  //   mdIcon: fingerPrintSharp
  // },
  // {
  //   title: 'Terms Of Use',
  //   // url: '/page/Terms',
  //   url: '/terms-of-use',
  //   iosIcon: informationCircleOutline,
  //   mdIcon: informationCircleSharp
  // },
  {
    title: "Settings",
    // url: '/page/Settings',
    url: "/settings",
    iosIcon: cogIcon,
    iosIconSelected: cogWhiteIcon,
    mdIcon: cogIcon,
  },
];

// const getImageDataURI = (data: any) => {
//   let pngBuffer = qr.imageSync(data, { type: "png" });
//   return "data:image/png;charset=utf-8;base64, " + pngBuffer.toString("base64");
// };

interface Props {
  user: any;
  identity: any;
  token: any;
}

const Menu: React.FC<Props> = React.memo(({ user, identity, token }) => {
  const [state, dispatch] = useTracked();
  const history = useHistory();
  const location = useLocation();
  const menuRef = useRef<any>(null);
  const [submenuToggle, setSubmenuToggle] = useState<boolean>(false);
  const [isOpenQr, setIsOpenQr] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  // let qrCode: any = getImageDataURI(identity || "anonymous");

  const closeMenu = async () => {
    if (menuRef && menuRef.current) {
      await menuRef.current.close();
    }
  };

  const handleLogout = async () => {
    userRemovePushToken(identity.toLowerCase(), state.pushToken);
    await identityService.logout();
    await updateVaultAuth();

    if (state.mqm) {
      await state.mqm.pubnub.publish({
        channel: identity.toLowerCase(),
        meta: {
          type: "logout",
        },
        message: { appId: process.env.REACT_APP_APP_ID },
      });
    }
    
    history.replace("/", { direction: "none" });
  };

  const updateVaultAuth = async () => {
    const { authMode, biometricType, hasSession, biometricsSupported } =
      await loadAuthMode();

    dispatch({
      type: "setVaultAuth",
      authMode,
      biometricType,
      hasSession,
      biometricsSupported,
    });
  };

  const isMenuSelected = (url: string) => {
    return location.pathname === url;
  };

  const handleAccountClick = async () => {
    try {
      setIsLoading(true);
      const vault = await identityService.getVault();
      await Storage.set({ key: "isLockFromSwitchAccount", value: "true" });

      const isLocked = await vault.isLocked();
      const isPasscodeEnabled = await vault.isPasscodeEnabled();
      const isSecureStorageModeEnabled = await vault.isSecureStorageModeEnabled();

      if (!isSecureStorageModeEnabled) {
        if (!isLocked) {
          await identityService.lockOut();
          await MockDelay(3000);
        }

        if (isPasscodeEnabled) {
          setIsLoading(false);
        }

        await identityService.unlock();
        const session = await identityService.restoreSession();

        if (session && session.token && session.identity) {
          history.push("/accounts", { direction: "forward" });
        } else {
          ShowToastErrorMessage("You failed to authenticate.");
        }
      } else {
        history.push("/accounts", { direction: "forward" });
      }

      await Storage.remove({ key: "isLockFromSwitchAccount" });
      closeMenu();

      if (!isPasscodeEnabled) {
        setIsLoading(false);
      }
    } catch (e) {
      console.log(e);
      closeMenu();
      setIsLoading(false);
      await Storage.remove({ key: "isLockFromSwitchAccount" });
      ShowToastErrorMessage("You failed to authenticate.");
    } finally {
      const authMode = await identityService.getAuthMode();
      if (
        authMode === AuthMode.PasscodeOnly ||
        authMode === AuthMode.BiometricAndPasscode
      ) {
        dispatch({ type: "hideApplicationsPIN" });
        dispatch({ type: "setPINFailedAttempts", value: 0 });
      }

      if (location.pathname === "/accounts") {
        history.replace("/issuers");
      }
    }
  };

  return (
    <IonMenu
      contentId="main"
      type="overlay"
      disabled={!token}
      ref={menuRef}
    >
      <IonContent>
        <IonList id="account-list">
          <IonItem
            lines="none"
            detail={false}
            onClick={() => setIsOpenQr(true)}
          >
            <IonIcon className="qr" icon={qrIcon} />
          </IonItem>
          <IonItem
            className="account-item"
            lines="none"
            detail={true}
            onClick={handleAccountClick}
          >
            <IonThumbnail
              slot="start"
              style={{ background: user.accountColor || "#cf0000" }}
            >
              <IonIcon
                icon={
                  user.accountIcon
                    ? require(`../../assets/svg/accountIcons/${user.accountIcon}.svg`)
                    : fingerPrint
                }
              ></IonIcon>
            </IonThumbnail>
            <IonLabel>
              <h2>{user.accountLabel || user.username}</h2>
              <p>{user.email}</p>
            </IonLabel>
          </IonItem>
        </IonList>

        <IonList id="menu-list">
          <IonListHeader>Menu</IonListHeader>
          {/* <IonNote className="note-text">Share your abaxx.id using this QR Code</IonNote> */}

          {appPages.map((appPage, index) => {
            const { url, subMenus } = appPage;
            return (
              <React.Fragment key={index}>
                {subMenus ? (
                  <>
                    <IonItem
                      className="submenu-item"
                      lines="none"
                      detail={false}
                      onClick={() => {
                        setSubmenuToggle(!submenuToggle);
                      }}
                    >
                      <IonIcon
                        slot="start"
                        icon={
                          submenuToggle
                            ? appPage.iosIconSelected
                            : appPage.iosIcon
                        }
                      />
                      <IonLabel>{appPage.title}</IonLabel>
                      <IonIcon
                        className="toggle"
                        slot="end"
                        icon={submenuToggle ? chevronUp : chevronDown}
                      ></IonIcon>
                    </IonItem>
                    <IonMenuToggle>
                      <IonList className={clsx({ hidden: !submenuToggle })}>
                        {subMenus.map((subitem: any, i: number) => (
                          <IonItem
                            key={i}
                            className={
                              isMenuSelected(subitem.url) ? "selected" : ""
                            }
                            routerDirection="none"
                            routerLink={subitem.url}
                            lines="none"
                            detail={false}
                          >
                            <IonLabel>{subitem.title}</IonLabel>
                          </IonItem>
                        ))}
                      </IonList>
                    </IonMenuToggle>
                  </>
                ) : (
                  <IonItem
                    key={index}
                    className={isMenuSelected(appPage.url) ? "selected" : ""}
                    lines="none"
                    detail={false}
                    routerDirection="none"
                    routerLink={url}
                    onClick={closeMenu}
                  >
                    <IonIcon
                      slot="start"
                      icon={
                        isMenuSelected(appPage.url)
                          ? appPage.iosIconSelected
                          : appPage.iosIcon
                      }
                    />
                    <IonLabel>{appPage.title}</IonLabel>
                  </IonItem>
                )}
              </React.Fragment>
            );
          })}
        </IonList>

        <IonLoading isOpen={isLoading} />
      </IonContent>
      <IonFooter>
        <IonList id="inbox-list">
          <IonItem
            button={true}
            lines="none"
            detail={false}
            onClick={handleLogout}
          >
            <IonIcon slot="start" icon={logoutIcon} />
            <IonLabel>Log Out</IonLabel>
          </IonItem>
        </IonList>
      </IonFooter>

      <QrCodeModal isOpen={isOpenQr} setIsOpen={setIsOpenQr} />
    </IonMenu>
  );
});

const MemoizedMenu = () => {
  const [state] = useTracked();
  const { identity, token, user } = state;
  return <Menu user={user} identity={identity} token={token} />;
};

export default MemoizedMenu;
